import { Component, OnInit } from '@angular/core';
import { Router, RouterModule} from '@angular/router'

@Component({
    selector : 'app-dashboard',
    template: '<router-outlet></router-outlet>',
})

export class BlankLayoutComponent implements OnInit {
    constructor() {}

    ngOnInit() : void { }
}


// WEBPACK FOOTER //
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/src/app/layouts/blank-layout.component.ts